import { EmojiType, GetEmoji } from '@ui-components/assets/Emojis'
import { ReactNode } from 'react'
import { styled } from 'styled-components'

import { Colors } from '../../global/colors'
import { MainHeading } from './headingPrimitives'
import { StandardHeading, StandardHeadingProps } from './StandardHeading'

export interface PrimaryHeadingProps extends StandardHeadingProps {
  header: string
  headerCaption?: ReactNode
  id?: string
  additionalText?: ReactNode
  leadText?: ReactNode
  bodyText?: ReactNode
  tagName?: 'h1' | 'h2'
  emoji?: EmojiType
  isInfoHeading?: boolean
  className?: string
}

const EmojiWrapper = styled.div<{ $color: string }>`
  color: ${({ $color }) => $color};
`

export const PrimaryHeading = ({
  header,
  tagName = 'h1',
  id,
  emoji,
  isInfoHeading = false,
  ...rest
}: PrimaryHeadingProps) => {
  const color = isInfoHeading ? Colors.TextStrongestPrimary : Colors.TextMediumPrimary

  return (
    <StandardHeading
      header={
        <>
          {emoji && <EmojiWrapper $color={color}>{GetEmoji(emoji)}</EmojiWrapper>}
          <MainHeading tagName={tagName} id={id ?? 'main-heading'} color={color}>
            {header}
          </MainHeading>
        </>
      }
      {...rest}
      color={isInfoHeading ? color : undefined}
    />
  )
}
